import { CarryOutOutlined, PieChartOutlined } from "@ant-design/icons";
import { TextService } from "../../Services/TextService";
import { EventType } from "../../Types/EventType";

/**
 * The first choice when an event is created: take sign-ups or let guests vote for the best time.
 * The rest of the form shows the settings that belong to the chosen type.
 */
export const EventTypeSelect = (props: { value: EventType, onChange: (value: EventType) => void }) => {
    const GetText = TextService.GetText;

    const options = [
        {
            value: EventType.SignUp,
            icon: <CarryOutOutlined />,
            title: GetText("EventType_SignUp"),
            description: GetText("EventType_SignUpDescription"),
        },
        {
            value: EventType.Poll,
            icon: <PieChartOutlined />,
            title: GetText("EventType_Poll"),
            description: GetText("EventType_PollDescription"),
        },
    ];

    return <div style={{ display: "flex", flexWrap: "wrap", gap: "12px", alignItems: "stretch" }}>
        {options.map(option => {
            const selected = props.value === option.value;

            return <button
                key={option.value}
                type="button"
                aria-pressed={selected}
                data-testid={"event-type-" + option.value}
                onClick={() => props.onChange(option.value)}
                style={{
                    flex: "1 1 240px",
                    maxWidth: "340px",
                    textAlign: "left",
                    padding: "14px 16px",
                    borderRadius: "8px",
                    cursor: "pointer",
                    background: selected ? "#f0f6ff" : "#ffffff",
                    border: selected ? "2px solid var(--color-primary)" : "1px solid #d9d9d9",
                }}
            >
                <div style={{ fontSize: "16px", fontWeight: 600 }}>{option.icon} {option.title}</div>
                <div style={{ fontSize: "13px", color: "#666", marginTop: "4px" }}>{option.description}</div>
            </button>;
        })}
    </div>;
};
